"use client";

import type { EmailField } from "@payloadcms/plugin-form-builder/types";
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from "react-hook-form";

import { Input } from "@onclicks/sharedcomponents/ui/Input";
import { useTranslations } from "next-intl";
import React from "react";

import { FieldError } from "./FieldError";
import { FieldLabel } from "./FieldLabel";
import { fieldClassName } from "./fieldStyles";

export const Email: React.FC<
  EmailField & {
    errors: Partial<FieldErrorsImpl>;
    placeholder?: string;
    register: UseFormRegister<FieldValues>;
  }
> = ({ name, defaultValue, errors, label, placeholder, register, required }) => {
  const t = useTranslations("web_contact");

  return (
    <div className="flex flex-col gap-2">
      <FieldLabel htmlFor={name} label={label} required={required} />
      <Input
        defaultValue={defaultValue}
        id={name}
        type="email"
        autoComplete="email"
        placeholder={placeholder}
        aria-invalid={!!errors[name]}
        className={fieldClassName}
        {...register(name, {
          pattern: { value: /^\S[^\s@]*@\S+$/, message: t("invalid_email") },
          required,
        })}
      />
      {errors[name] && <FieldError name={name} />}
    </div>
  );
};
